var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view-cell',{attrs:{"context-menu-items":_vm.contextMenuItems}},[(_vm.note.status)?_c('div'):_vm._e(),_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.note.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }